import { NgModule } from '@angular/core';
import { PriceExchangeComponent } from './price-exchange.component';
import { CurrenciesSelectComponent } from './currencies-select/currencies-select.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    PriceExchangeComponent,
    CurrenciesSelectComponent,
  ],
  exports: [
    PriceExchangeComponent,
    CurrenciesSelectComponent,
  ],
  providers: [],
})
export class PriceExchangeModule {
}
